// src/lib/firebase.ts
import { initializeApp as initializeJSApp, type FirebaseApp as JSFirebaseApp, type FirebaseOptions } from "firebase/app";
// import { getAnalytics as getJSAnalytics, type Analytics as JSAnalytics, logEvent as logJSEvent, setUserProperties as setJSUserProperties } from "firebase/analytics"; // Not directly needed if using plugin for all analytics
import { FirebaseAnalytics } from "@capacitor-community/firebase-analytics";
import { isNativePlatform, getPlatformOS } from '../utils/platformUtils';
// import { getAuth, type Auth } from "firebase/auth"; // 如果需要 Auth
// import { getFirestore, type Firestore } from "firebase/firestore"; // 如果需要 Firestore
// import { getStorage, type FirebaseStorage } from "firebase/storage"; // 如果需要 Storage
// import { getFunctions, type Functions } from "firebase/functions"; // 如果需要 Functions
// import { getMessaging, type Messaging } from "firebase/messaging"; // 如果需要 Messaging
// import { getPerformance, type FirebasePerformance } from "firebase/performance"; // 如果需要 Performance
// import { getRemoteConfig, type RemoteConfig } from "firebase/remote-config"; // 如果需要 Remote Config

const firebaseConfig = { // Removed FirebaseOptions type annotation to let TypeScript infer types
  apiKey: "AIzaSyB-P6egHUmxWbg6REQ1U9TLiJf8MKTohMk",
  authDomain: "tempo-38b81.firebaseapp.com",
  projectId: "tempo-38b81",
  storageBucket: "tempo-38b81.firebasestorage.app",
  messagingSenderId: "1023901293892",
  appId: "1:1023901293892:web:12aff14645d9f2a4c90b11",
  measurementId: "G-S415KPS3F5"
};

let app: JSFirebaseApp | null = null;
// The plugin itself doesn't directly expose an 'analytics' instance. We use its static methods.

const initializeFirebaseServices = async () => {
  try {
    if (isNativePlatform()) {
      // For native platforms, the plugin handles initialization via GoogleService-Info.plist / google-services.json
      // We just need to ensure collection is enabled.
      await FirebaseAnalytics.setCollectionEnabled({ enabled: true });
      console.log("Capacitor Firebase Analytics collection enabled for native platform.");
      // You might log a specific native_app_open event here if desired
      await FirebaseAnalytics.logEvent({ name: "native_app_open", params: { platform: getPlatformOS() }});
    } else {
      // For Web (and environments where Capacitor.isNativePlatform() is false)
      app = initializeJSApp(firebaseConfig);
      console.log("Firebase JS App initialized successfully for Web.");

      // Use type assertion to satisfy the plugin's expected parameter type
      await FirebaseAnalytics.initializeFirebase(firebaseConfig as any);
      console.log("Capacitor Firebase Analytics plugin initialized for Web via JS SDK.");
      await FirebaseAnalytics.setCollectionEnabled({ enabled: true });
      await FirebaseAnalytics.logEvent({ name: "web_app_open", params: { platform: 'web' }});
    }

  } catch (error) {
    console.error("Error initializing Firebase services:", error);
  }
};

// Call initialization early
initializeFirebaseServices();

// Export the plugin directly so its static methods can be used
// Also export the JS app instance if needed for other Firebase JS SDK services (Auth, Firestore, etc.)
export { FirebaseAnalytics as AnalyticsPlugin, app as firebaseJSApp };

// Initialize other Firebase services as needed:
// auth = getAuth(app);
// firestore = getFirestore(app);
// storage = getStorage(app);
// functions = getFunctions(app);
// messaging = getMessaging(app);
// performance = getPerformance(app);
// remoteConfig = getRemoteConfig(app);
// await fetchAndActivate(remoteConfig); // Example for Remote Config

// let analytics: Analytics | null = null;
// let auth: Auth | null = null; // Uncomment if needed
// let firestore: Firestore | null = null; // Uncomment if needed
// let storage: FirebaseStorage | null = null; // Uncomment if needed
// let functions: Functions | null = null; // Uncomment if needed
// let messaging: Messaging | null = null; // Uncomment if needed
// let performance: FirebasePerformance | null = null; // Uncomment if needed
// let remoteConfig: RemoteConfig | null = null; // Uncomment if needed

// try {
//   app = initializeApp(firebaseConfig);
//   console.log("Firebase app initialized successfully.");

//   // Initialize Analytics and get a reference to the service
//   // Ensure this is called only in a browser environment
//   if (typeof window !== 'undefined' && firebaseConfig.measurementId) {
//     analytics = getAnalytics(app);
//     console.log("Firebase Analytics initialized successfully.");
//   } else {
//     console.log("Firebase Analytics not initialized (not in browser or no measurementId).");
//   }

//   // Initialize other Firebase services as needed:
//   // auth = getAuth(app);
//   // firestore = getFirestore(app);
//   // storage = getStorage(app);
//   // functions = getFunctions(app);
//   // messaging = getMessaging(app);
//   // performance = getPerformance(app);
//   // remoteConfig = getRemoteConfig(app);
//   // await fetchAndActivate(remoteConfig); // Example for Remote Config

// } catch (error) {
//   console.error("Error initializing Firebase:", error);
// }

// export { app, analytics /*, auth, firestore, storage, functions, messaging, performance, remoteConfig */ };